import axios from 'axios';

const API_URL = process.env.REACT_APP_BASEURL + 'sscs';

export const getAllSkillSectors = (params: { search?: string; limit?: number; skip?: number }) => {
  return axios.get(`${API_URL}/all`, { params });
};

export const createSkillSector = (payload: any) => {
  return axios.post(`${API_URL}/`, payload);
};

export const updateSkillSector = (id: string, payload: any) => {
  const body = {
    id,
    ...payload
  };

  return axios.put(`${API_URL}/`, body);
};

export const deleteSkillSector = (id: string) => {
  if (!id) throw new Error('deleteSkillSector: Missing ID');

  return axios.delete(`${API_URL}/`, {
    data: { id }
  });
};
